import { mapGetters } from 'vuex';

export default {
  watch: {
    currentTeamId: {
      immediate: true,
      handler(teamId) {
        if (!teamId || this.teamMembers.length) {
          return;
        }

        this.$store.dispatch('teamMembers/get', { teamId });
      },
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      currentAccountId: 'getCurrentAccountId',
    }),
    currentTeamId() {
      return this.currentChat?.meta?.team?.id;
    },
    teamMembers() {
      if (!this.currentTeamId) {
        return [];
      }

      return this.$store.getters['teamMembers/getTeamMembers'](
        this.currentTeamId
      );
    },
    inboxAssignableAgents() {
      return this.$store.getters['inboxAssignableAgents/getAssignableAgents'](
        this.inboxId
      );
    },
    assignableAgents() {
      return this.inboxAssignableAgents;
    },
    filteredAssignableAgents() {
      const agents = this.inboxAssignableAgents || [];
      if (!this.currentTeamId) {
        return agents;
      }

      const memberIds = new Set(this.teamMembers.map(member => member.id));
      return agents.filter(agent => memberIds.has(agent.id));
    },
    isAgentSelected() {
      return this.currentChat?.meta?.assignee;
    },
    createNoneAgent() {
      return {
        confirmed: true,
        name: this.$t('COMMON.AGENT_NONE'),
        id: 0,
        role: 'agent',
        account_id: 0,
        email: 'None',
      };
    },
    agentsList() {
      const agents = this.filteredAssignableAgents || [];
      const agentsByUpdatedPresence = this.getAgentsByUpdatedPresence(agents);
      const none = this.createNoneAgent;
      const filteredAgentsByAvailability = this.sortedAgentsByAvailability(
        agentsByUpdatedPresence
      );
      const filteredAgents = [
        ...(this.isAgentSelected ? [none] : []),
        ...filteredAgentsByAvailability,
      ];
      return filteredAgents;
    },
  },
  methods: {
    getAgentsByAvailability(agents, availability) {
      return agents
        .filter(agent => agent.availability_status === availability)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedAgentsByAvailability(agents) {
      const onlineAgents = this.getAgentsByAvailability(agents, 'online');
      const busyAgents = this.getAgentsByAvailability(agents, 'busy');
      const offlineAgents = this.getAgentsByAvailability(agents, 'offline');
      const filteredAgents = [...onlineAgents, ...busyAgents, ...offlineAgents];
      return filteredAgents;
    },
    getAgentsByUpdatedPresence(agents) {
      // Here we are updating the availability status of the current user dynamically (live) based on the current account availability status
      const agentsWithDynamicPresenceUpdate = agents.map(item =>
        item.id === this.currentUser.id
          ? {
              ...item,
              availability_status: this.currentUser.accounts.find(
                account => account.id === this.currentAccountId
              ).availability_status,
            }
          : item
      );
      return agentsWithDynamicPresenceUpdate;
    },
  },
};
